// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.chat-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.caption-toggle {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.caption-toggle:hover {
  background-color: #f0f0f0;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.message {
  display: flex;
  flex-direction: column;
  max-width: 80%;
  padding: 12px;
  border-radius: 8px;
}

.message-user {
  align-self: flex-end;
  background-color: #0066cc;
  color: white;
}

.message-assistant {
  align-self: flex-start;
  background-color: #f0f0f0;
  color: #333;
}

.message-content {
  word-wrap: break-word;
  line-height: 1.5;
}

.message-timestamp {
  font-size: 11px;
  opacity: 0.7;
  margin-top: 4px;
}

.chat-status {
  padding: 8px 16px;
  min-height: 32px;
  display: flex;
  align-items: center;
}

.status-indicator {
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 4px;
}

.status-indicator.listening {
  background-color: #e3f2fd;
  color: #1976d2;
}

.status-indicator.speaking {
  background-color: #fff3e0;
  color: #f57c00;
}

.chat-input-form {
  display: flex;
  padding: 16px;
  border-top: 1px solid #e0e0e0;
  gap: 8px;
}

.chat-input {
  flex: 1;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.chat-input:focus {
  outline: none;
  border-color: #0066cc;
}

.send-button {
  padding: 10px 20px;
  background-color: #0066cc;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.send-button:hover:not(:disabled) {
  background-color: #0052a3;
}

.send-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

`, "",{"version":3,"sources":["webpack://./src/components/ChatPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,6BAA6B;EAC7B,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".chat-panel {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.chat-header h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.caption-toggle {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.caption-toggle:hover {\n  background-color: #f0f0f0;\n}\n\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.message {\n  display: flex;\n  flex-direction: column;\n  max-width: 80%;\n  padding: 12px;\n  border-radius: 8px;\n}\n\n.message-user {\n  align-self: flex-end;\n  background-color: #0066cc;\n  color: white;\n}\n\n.message-assistant {\n  align-self: flex-start;\n  background-color: #f0f0f0;\n  color: #333;\n}\n\n.message-content {\n  word-wrap: break-word;\n  line-height: 1.5;\n}\n\n.message-timestamp {\n  font-size: 11px;\n  opacity: 0.7;\n  margin-top: 4px;\n}\n\n.chat-status {\n  padding: 8px 16px;\n  min-height: 32px;\n  display: flex;\n  align-items: center;\n}\n\n.status-indicator {\n  font-size: 14px;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.status-indicator.listening {\n  background-color: #e3f2fd;\n  color: #1976d2;\n}\n\n.status-indicator.speaking {\n  background-color: #fff3e0;\n  color: #f57c00;\n}\n\n.chat-input-form {\n  display: flex;\n  padding: 16px;\n  border-top: 1px solid #e0e0e0;\n  gap: 8px;\n}\n\n.chat-input {\n  flex: 1;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.chat-input:focus {\n  outline: none;\n  border-color: #0066cc;\n}\n\n.send-button {\n  padding: 10px 20px;\n  background-color: #0066cc;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.send-button:hover:not(:disabled) {\n  background-color: #0052a3;\n}\n\n.send-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
